<!-- Breadcrumb Area -->


<!-- <div class="row" id="result-general">
    <div [ngClass]="!show[1].showing?'col':'col-lg-6 col-md-12'" *ngIf="show[0].showing">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GRAFICA DE RESULTADOS</h3>
                <div class="dropdown">
                    <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class='bx bx-dots-horizontal-rounded'></i>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-show'></i> View
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-edit-alt'></i> Edit
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-trash'></i> Delete
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-printer'></i> Print
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-download'></i> Download
                        </a>
                    </div>
                </div>
            </div>
            <app-accounting-chart-result></app-accounting-chart-result>
        </div>
    </div>
    <div [ngClass]="!show[0].showing?'col':'col-lg-6 col-md-12'" id="general-chart" *ngIf="show[1].showing">
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GRÁFICO DE BALANCE GENERAL <span class="text-muted" data-bs-toggle="tooltip"
                        data-bs-title="Haz click sobre una columna para ver el detalle de la misma"><i
                            class="fa fa-circle-info"></i></span></h3>

                <div class="dropdown">
                    <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class='bx bx-dots-horizontal-rounded'></i>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-show'></i> View
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-edit-alt'></i> Edit
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-trash'></i> Delete
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-printer'></i> Print
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-download'></i> Download
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class="fa-regular fa-star"></i> Agregar a favoritos
                        </a>

                    </div>
                </div>
            </div>
            <app-accounting-chart-balance></app-accounting-chart-balance>
        </div>
    </div>
</div>
<div class="row" *ngIf="show[2].showing">
    <div class="col">
        Website Website Analytics
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GRÁFICO DE GASTOS</h3>
                <div class="dropdown">
                    <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class='bx bx-dots-horizontal-rounded'></i>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-show'></i> View
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-edit-alt'></i> Edit
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-trash'></i> Delete
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-printer'></i> Print
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-download'></i> Download
                        </a>
                    </div>
                </div>
            </div>
            <app-accounting-chart-expenses></app-accounting-chart-expenses>
        </div>
        End Website Analytics
    </div>
</div>
<div class="row" *ngIf="show[3].showing">
    <div class="col">
        Website Website Analytics
        <div class="card mb-30">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>GRÁFICO DE GANANCIAS VS COSTOS Y GASTOS</h3>
                <div class="dropdown">
                    <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class='bx bx-dots-horizontal-rounded'></i>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-show'></i> View
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-edit-alt'></i> Edit
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-trash'></i> Delete
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-printer'></i> Print
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="javascript:void(0)">
                            <i class='bx bx-download'></i> Download
                        </a>
                    </div>
                </div>
            </div>
            <app-accounting-chart-profits-vs-costs></app-accounting-chart-profits-vs-costs>
        </div>
    </div>
</div>
<div *ngIf="empty" class="card">
    <div class="card-body">
        <h2><i class="fa fa-circle-info"></i> No hay favoritos aún, selecciona algún favorito en
            <a routerLink="/dashboard/analytics">
                <i class="fa-solid fa-chart-pie"></i>
                Reporte Gerencial
            </a>
        </h2>
    </div>

</div> -->

<div class="breadcrumb-area">
    <h1>Reporte Facturas de Cliente</h1>
</div>


<div *ngIf="dashboardUrl" style="overflow: hidden; height: 580px; margin-bottom: 10px;">
    <iframe
        [src]="dashboardUrl"
        width="100%"
        height="600px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin">
    </iframe>
</div>

<div *ngIf="dashboardProducts" style="overflow: hidden; height: 580px; margin-bottom: 10px;">
    <iframe
        [src]="dashboardProducts"
        width="100%"
        height="600px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin">
    </iframe>
</div>

<div *ngIf="dashboardWarehouse" style="overflow: hidden; height: 580px;">
    <iframe
        [src]="dashboardWarehouse"
        width="100%"
        height="600px"
        frameborder="0"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin">
    </iframe>
</div>